import { render, staticRenderFns } from "./TaxPreview.vue?vue&type=template&id=5a228e5c"
import script from "./TaxPreview.vue?vue&type=script&lang=js"
export * from "./TaxPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TaxPreview.vue"
export default component.exports